export const STRIPE_ELEMENTS_APPEARANCE = {
  theme: 'stripe' as const,
  variables: {
    colorPrimary: '#15172E',
    colorBackground: '#FFFFFF',
    colorText: '#555963',
    colorDanger: '#dc2626',
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    spacingUnit: '4px',
    borderRadius: '6px'
  }
};

export const STRIPE_ELEMENT_STYLE = {
  base: {
    fontSize: '14px',
    color: '#555963',
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    '::placeholder': {
      color: '#9CA3AF'
    }
  },
  invalid: {
    color: '#dc2626'
  }
};

export function createStripeElementConfig(placeholder: string) {
  return {
    placeholder,
    style: STRIPE_ELEMENT_STYLE
  };
}
